export default "__VITE_ASSET__B_a7lcAq__"